module.exports = __webpack_public_path__ + "6d34cf1c6.png";